import { axiosFactory, errorHandler } from "@/configs/axios";
import i18n from "@/plugins/i18n";
// import { Loading } from "element-ui";

const state = () => ({
  refCount: 0,
  isLoading: false,
  navbar: false,
  drawer: false,
  notifCount: 0,
  locale: i18n.locale,
});

const getters = {
  navbar(state) {
    return state.navbar;
  },
  isLoading(state) {
    return state.isLoading;
  },
  drawer(state) {
    return state.drawer;
  },
  notifCount(state) {
    return state.notifCount;
  },
  locale(state) {
    return state.locale;
  },
};
const mutations = {
  LOADING(state, isLoading) {
    if (isLoading) {
      state.refCount++;
      state.isLoading = true;
    } else if (state.refCount > 0) {
      state.refCount--;
      state.isLoading = state.refCount > 0;
    }
  },
  OPEN_NAVBAR(state, payload) {
    state.navbar = payload;
  },
  OPEN_DRAWER(state, payload) {
    state.drawer = payload;
  },
  NOTIF_COUNT(state, payload) {
    state.notifCount = payload;
  },
  updateLocale(state, newLocale) {
    state.locale = newLocale;
  },
};
const actions = {
  notifications(context) {
    return axiosFactory()
      .auth.get("/notifications/")
      .then((res) => {
        let data = res.data;
        context.commit("NOTIF_COUNT", data.length);
        return data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
  readNotification(context, payload) {
    return axiosFactory()
      .auth.put(`/notifications/${payload}/read/`, {
        read: true,
      })
      .then((res) => {
        context.commit("NOTIF_COUNT", context.getters.notifCount - 1);
        return res;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
  readAllNotifications(context) {
    return axiosFactory()
      .auth.post("/notifications/read/")
      .then((res) => {
        context.commit("NOTIF_COUNT", 0);
        return res;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
  changeLocale({ commit }, newLocale) {
    // const loading = Loading.service({
    //   lock: true,
    //   text: "Loading",
    //   spinner: "el-icon-loading",
    //   background: "rgba(0, 0, 0, 0.7)",
    // });
    i18n.locale = newLocale;
    commit("updateLocale", newLocale);
    let bodyClass = document.body.classList;
    if (newLocale == "fa") {
      bodyClass.add("fa");
      bodyClass.remove("en");
    } else {
      bodyClass.remove("fa");
      bodyClass.add("en");
    }
    // setTimeout(() => {
    //   loading.close();
    // }, 1000);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
